<template>
    <LockDesignerPanel @update-route="handleUpdateRoute" @update-selection="handleUpdateSelection"></LockDesignerPanel>
</template>
<script lang="ts">
import LockDesignerPanel from 'Vue/components/lockDesigner/components/LockDesignerPanel.vue';
import { mapGetters, mapActions } from 'vuex'; // Import useStore from vuex

export default {
    name: 'LockDesignerLanding',
    components: {
        LockDesignerPanel,
    },
    computed: {
        ...mapActions(['fetchSelections', 'resetComponentGroups', 'updateSelections']),
        ...mapGetters(['componentGroups', 'isLoadingDefault']),
    },

    emits: ['update-route'],

    mounted() {
        if (!this.isLoadingDefault) {
            this.handleFetchPageData();
        }
    },
    async unmounted() {
        await this.$store.dispatch('resetComponentGroups');
    },

    methods: {
        handleUpdateRoute(route: any) {
            this.$emit('update-route', route);
        },
        async handleUpdateSelection(selection) {
            await this.$store.dispatch('updateSelections', selection);
        },
        async handleFetchPageData() {
            await this.$store.dispatch('fetchSelections', { optionChanged: 'None' });
        },
    },
};
</script>
